import { Box, Stack } from '@mui/material';
import { ControlledList, DataGridLayoutGrid, RelationListLayout } from 'framework/list';
import { CareerSectionHeader, EmployeePortalHeader } from './components/ExpertiseHeaders';
import { useExpertiseGetData } from './service/expertiseHooks';
import {
  ExpertiseExperienceDurationShortLabels,
  ExpertiseExperienceTypeLabels,
  ExpertiseLevelLabels,
} from './service/expertiseService.model';
import { Loading } from 'framework/ui/mui-builder';
import { EnumField, ExpandingTooltipField, TextField } from 'framework/ui/field';
import ConfirmChipField from './components/ConfirmChipField';
import EditExpertiseAction from './components/actions/edit/EditExpertiseAction';
import DeleteExpertiseAction from './components/actions/delete/DeleteExpertiseAction';
import CreateExpertiseAction from './components/actions/createNew/CreateExpertiseAction';
import { useIsMyProfile } from 'domain/shared/employee';

const ExpertiseSection = () => {
  const { currentData, isLoading } = useExpertiseGetData();
  const isEmployeePortal = useIsMyProfile();

  if (isLoading) {
    return <Loading />;
  }

  if (!currentData) {
    return null;
  }

  const fields = [
    <TextField key="expertise.displayName" source="expertise.displayName" />,
    <EnumField key="level" source="level" options={ExpertiseLevelLabels} />,
    <EnumField
      key="experienceDuration"
      source="experienceDuration"
      options={ExpertiseExperienceDurationShortLabels}
      size={1}
    />,
    <EnumField key="expertiseType" source="expertiseType" options={ExpertiseExperienceTypeLabels} />,
    ...(isEmployeePortal
      ? []
      : [
          <ExpandingTooltipField key="comment" source="comment" maxValueLength={55}>
            <TextField source="comment"></TextField>
          </ExpandingTooltipField>,
        ]),
    <ConfirmChipField key="confirm" />,
  ];

  const buttons = isEmployeePortal
    ? undefined
    : [<EditExpertiseAction key="edit" />, <DeleteExpertiseAction key="delete" />];

  const title = isEmployeePortal ? <EmployeePortalHeader /> : <CareerSectionHeader />;
  const width = currentData.items.length ? (isEmployeePortal ? '500px' : '800px') : '300px';

  return (
    <ControlledList data={currentData}>
      <Stack gap={isEmployeePortal ? 1.5 : undefined}>
        {title}
        <RelationListLayout sxHeaderContainer={{ mb: '0 !important' }}>
          <DataGridLayoutGrid
            minWidth={width}
            showTotal={false}
            isShowHeader={false}
            buttons={buttons}
            rowProps={{
              sxRowContainer: {
                border: 0,
                m: 0,
                px: 0,
              },
              sx: {
                alignItems: 'center',
              },
            }}
          >
            {fields}
          </DataGridLayoutGrid>
        </RelationListLayout>
        {!isEmployeePortal && (
          <Box>
            <CreateExpertiseAction />
          </Box>
        )}
      </Stack>
    </ControlledList>
  );
};

export default ExpertiseSection;
